import React from 'react';
import styles from './CollectionBreakdown.module.css';

const CollectionBreakdown = ({ data = [] }) => {
    return (
        <div className={styles.card}>
            <h3 className={styles.title}>Collection Breakdown</h3>
            {data.length === 0 ? (
                <div style={{ padding: '20px 0', fontSize: '11.5px', color: 'var(--h-color-neutral-400)', fontWeight: 700 }}>No collections yet.</div>
            ) : (
                <div className={styles.list}>
                    {data.map((item, idx) => (
                        <div key={idx} className={styles.item}>
                            <div className={styles.info}>
                                <span className={styles.method}>{item.method}</span>
                                <span className={styles.amount}>{item.amount}</span>
                            </div>
                            <div className={styles.progressBg}>
                                <div className={styles.progressFill} style={{ width: `${item.percent}%`, backgroundColor: item.color }}></div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
export default CollectionBreakdown;